import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../config/api";

/**
 * Fetches the current user's staff record from GET /staff/me.
 * Returns { email, isAdmin, loading }.
 *
 * Derives the user identity from sessionStorage/localStorage (same
 * fallback chain used elsewhere) and sends it via X-Bonsai-User-Email.
 * The backend is authoritative for is_admin — no client-side
 * hardcoded ADMIN_EMAILS list needed.
 */
export function useCurrentUser() {
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const userEmail = (
      sessionStorage.getItem("bonsai_user_email") ||
      localStorage.getItem("bonsai_user_email") ||
      sessionStorage.getItem("bonsai_user_id") ||
      ""
    ).toLowerCase();

    if (!userEmail) {
      setLoading(false);
      return;
    }

    setEmail(userEmail);

    axios
      .get(`${API}/staff/me`, {
        headers: {
          "X-Bonsai-User-Email": userEmail,
          "X-Bonsai-User-Id":
            sessionStorage.getItem("bonsai_user_id") ||
            localStorage.getItem("bonsai_user_id") ||
            "",
        },
      })
      .then((res) => {
        setIsAdmin(!!res.data?.is_admin);
        setEmail(res.data?.email || userEmail);
      })
      .catch(() => {
        // On failure, fall back to false — no admin powers.
        setIsAdmin(false);
      })
      .finally(() => setLoading(false));
  }, []);

  return { email, isAdmin, loading };
}
